<main class="mat-body" *ngIf="appropriatenessClient">
    <div class="bg-white py-3">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row flex-nowrap justify-content-between align-items-end">
                        <div class="col-auto flex-shrink-1">
                            <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'operative.operate'|translate"></h1>
                        </div>
                        <div class="col-auto">
                            <i class="icon-operative-natural text-blue"></i>
                        </div>
                    </div>
                    <hr class="mt-1 mb-2" />
                </div>
                <div class="col-12 col-md-6">
                    <button
                        type="button"
                        class="full-width mat-elevation-z0"
                        [class.active]="isMyProducts"
                        mat-raised-button
                        color="gray"
                        (click)="onAddMyProducts()"
                    >
                        {{ 'operative.operate-with-my-products'|translate }}
                    </button>
                </div>
                <div class="col-12 col-md-6 mt-3 mt-md-0">
                    <button
                        type="button"
                        class="full-width mat-elevation-z0"
                        [class.active]="!isMyProducts"
                        mat-raised-button
                        [disabled]="isExpiredDoc || isExpiredTest"
                        color="gray"
                        (click)="onAddProducts()"
                    >
                        {{ 'operative.add-products'|translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="bg-white py-3" *ngIf="(lowProducts.length === 0) && (moderateProducts.length === 0) && (highProducts.length === 0)">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <h2 class="text-blue mb-0" [innerHTML]="'operative.no-products'|translate"></h2>
                </div>
            </div>
        </div>
    </div>

    <mat-accordion class="products" *ngIf="lowProducts.length > 0">
        <mat-expansion-panel class="mat-elevation-z0" (afterCollapse)="onAccordionChange()" (afterExpand)="onAccordionChange()">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h2 class="text-blue mat-display-1 mb-0" [innerHTML]="'product.low-knowles'|translate"></h2>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="bg-blue-gradient pt-4">
                <div class="container">
                    <div class="row">
                        <ng-template ngFor let-product [ngForOf]="lowProducts">
                            <div class="col-12 col-sm-6 col-lg-4 mb-4">
                                <thr-product-card
                                    [product]="product"
                                    [isAppropriateness]="appropriatenessClient.isProductConvenience(product)"
                                    (detail)="onDetail($event)"
                                ></thr-product-card>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion class="products" *ngIf="moderateProducts.length > 0">
        <mat-expansion-panel class="mat-elevation-z0" (afterCollapse)="onAccordionChange()" (afterExpand)="onAccordionChange()">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h2 class="text-blue mat-display-1 mb-0" [innerHTML]="'product.moderate-knowles'|translate"></h2>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="bg-blue-gradient pt-4">
                <div class="container">
                    <div class="row">
                        <ng-template ngFor let-product [ngForOf]="moderateProducts">
                            <div class="col-12 col-sm-6 col-lg-4 mb-4">
                                <thr-product-card
                                    [product]="product"
                                    [isAppropriateness]="appropriatenessClient.isProductConvenience(product)"
                                    (detail)="onDetail($event)"
                                ></thr-product-card>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion class="products" *ngIf="highProducts.length > 0">
        <mat-expansion-panel class="mat-elevation-z0" (afterCollapse)="onAccordionChange()" (afterExpand)="onAccordionChange()">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h2 class="text-blue mat-display-1 mb-0" [innerHTML]="'product.high-knowles'|translate"></h2>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="bg-blue-gradient pt-4">
                <div class="container">
                    <div class="row">
                        <ng-template ngFor let-product [ngForOf]="highProducts">
                            <div class="col-12 col-sm-6 col-lg-4 mb-4">
                                <thr-product-card
                                    [product]="product"
                                    [isAppropriateness]="appropriatenessClient.isProductConvenience(product)"
                                    (detail)="onDetail($event)"
                                ></thr-product-card>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <div class="container">
        <div class="row justify-content-end mt-5 mb-4">
            <div class="col-12 col-sm-6 col-md-4">
                <button
                    type="button"
                    class="full-width mat-elevation-z0"
                    mat-raised-button
                    color="blue"
                    [disabled]="!canContinue"
                    (click)="onClick()"
                >
                    {{ 'operative.add-to-operate'|translate }}
                </button>
            </div>
        </div>
    </div>
</main>
